import styled from '@emotion/styled';

const StyledCoreUtils = styled.div`
  color: pink;
`;

export function CoreUtils() {
  return (
    <StyledCoreUtils>
      <h1>Welcome to CoreUtils!</h1>
    </StyledCoreUtils>
  );
}

export default CoreUtils;
